// css =>
import './App.css';

// react =>
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Route, Routes } from 'react-router-dom';

// pages =>
import LogIn from './Pages/LogIn/LogIn.page';
import SignIn from './Pages/SignIn/SignIn.page';
import NotFound from './Pages/NotFound(404)/NotFound.page';
import MainPage from "./Pages/MainPage/MainPage.page";
import OrderShow from './Pages/OrderShow/OrderShow.page';
import Favorites from './Pages/Favorites/Favorites.page';
import ProductInfo from './Pages/ProductInfo/ProductInfo.page';
import EditProfile from './Pages/EditProfile/EditProfile.page';
import CodeReceive from './Pages/CodeReceive/CodeReceive.page';
import OrderHistory from './Pages/OrderHistory/OrderHistory.page';
import ShowProducts from './Pages/ShowProducts/ShowProducts.page';
import ShoppingCard from './Pages/ShoppingCard/ShoppingCard.page';
import ShowOrderDetails from './Pages/ShowOrderDetails/ShowOrderDetails.page';
import WelcomePageFromLogIn from './Pages/WelcomePageFromeLogIn/WelcomePageFromeLogIn.page';
import WelcomePageFromSignIn from './Pages/WelcomePageFromSignIn/WelcomePageFromSignIn.page';

// context =>
import { MessageProvider } from "./Contexts/MessageBoxContext";

// routes =>
import PublicRoute from "./Components/routes/PublicRoute";
import PrivateRoute from "./Components/routes/PrivateRoute";

// Animation =>
import AOS from 'aos';
import 'aos/dist/aos.css';

AOS.init({
  duration: 900,
  once: true,
  easing: 'ease-in-out',
});

function App() {

  const location = useLocation();

  useEffect(() => {
    AOS.refresh();
  }, [location]);

  return (
    <MessageProvider>
      <Routes>
        <Route path="/" element={ <MainPage /> } />
        <Route path='*' element={ <NotFound /> } />
        <Route path="/log-in" element={ <PublicRoute><LogIn /></PublicRoute> } />
        <Route path="/sign-in" element={ <PublicRoute><SignIn /></PublicRoute> } />
        <Route path="/favorites" element={ <Favorites /> } />
        <Route path="/order-show" element={ <OrderShow /> } />
        <Route path="/order-history" element={ <OrderHistory /> } />
        <Route path="/product-info/:productName?/:productId" element={ <ProductInfo /> } />
        <Route path="/edit-profile" element={ <EditProfile /> } />
        <Route path="/shopping-card" element={ <ShoppingCard /> } />
        <Route path="/show-products" element={ <ShowProducts /> } />
        <Route path="/code-receive" element={ <CodeReceive /> } />
        <Route path="/order-details" element={ <ShowOrderDetails /> } />
        <Route path="/welcome-log-in" element={ <WelcomePageFromLogIn /> } />
        <Route path="/welcome-sign-in" element={ <WelcomePageFromSignIn /> } />
      </Routes>
    </MessageProvider>
  );
}

export default App;
